export const getColumnOne = (november2021Pricing?: boolean) => [
  'Unified inbox to view, filter and respond to all customer chat conversations across messaging channels',
  november2021Pricing ? '1,000 send credits/month' : '6,500 send credits/month',
  '1 user seat with optional seat add-ons',
  'Advanced bot automations',
];

export const columnTwo = [
  'Office hours autoresponder',
  'Zapier integrations',
  'Facebook Messenger and Instagram Direct messaging ads',
  'Conversation and contact analytics',
  '1 hour team onboarding call',
];
